import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { getServiceDeficitPanelDisplay } from '../../../utils/serviceDeficitDisplay';
import {
  LOT_INFO_FIELD_ROW_SX,
  LotInfoMetricIndicator,
  lotInfoFieldLabelLayoutSx,
  lotInfoFieldValueSx,
} from './formBlockUi';

const TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      textAlign: 'center',
      maxWidth: 280,
      whiteSpace: 'normal',
      fontSize: '12px',
      lineHeight: 1.4,
    },
  },
  popper: {
    modifiers: [
      {
        name: 'preventOverflow',
        options: { padding: 12, altAxis: true },
      },
      { name: 'flip', enabled: true },
    ],
  },
};

/**
 * Fila de déficit de servicio básico.
 */
const LotServicioDeficitRow = ({ indicator, value = null }) => {
  const display = getServiceDeficitPanelDisplay(value, indicator);

  return (
    <Box sx={LOT_INFO_FIELD_ROW_SX}>
      <Typography sx={lotInfoFieldLabelLayoutSx()}>
        {indicator.shortLabel}
      </Typography>

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '7px',
        }}
      >
        <Tooltip
          title={display.tooltip}
          placement="top"
          arrow
          slotProps={TOOLTIP_SLOT_PROPS}
        >
          <Box
            component="span"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '7px',
              maxWidth: '100%',
              cursor: 'help',
            }}
          >
            <LotInfoMetricIndicator color={display.accentColor} />
            <Typography
              component="span"
              sx={lotInfoFieldValueSx({ muted: display.isMissing })}
            >
              {display.valueLabel}
            </Typography>
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default LotServicioDeficitRow;
